const formatNumber = (value, suffix = '') => {
    if (value === undefined || value === null) return '-';
    return `${String(value).replace(/(.)(?=(\d{3})+$)/g, '$1,')}${suffix}`;
};

const compactLayout = (label) => {
    if (!label || label.length < 8) {
        return { svgWidth: '80', circleX: '67', rectWidth: '55', textX: 0 };
    }
    return { svgWidth: '90px', circleX: '77', rectWidth: '65', textX: 5 };
};

export const buildHousingSymbol = (feature, type) => {
    let label = '';
    if (type?.includes('housing')) {
        label = `${formatNumber(feature.get('stock'))} 호`;
    } else if (type?.includes('rental_ratio')) {
        label = `${formatNumber(feature.get('trde_deal'))} %`;
    } else if (type?.includes('sale')) {
        label = feature.get('trd') === 0 ? '-' : `${formatNumber(feature.get('trd'))} 만원`;
    } else if (type?.includes('rental_price')) {
        label = feature.get('deposit') === 0 ? '-' : `${formatNumber(feature.get('deposit'))} 만원`;
    } else {
        label = `${formatNumber(feature.get('stock'))} 호`;
    }

    const hjdNm = (feature.get('hjd_nm') || '').trim();
    const hjdLabel = hjdNm.split(' ').length > 1 ? hjdNm.split(' ').slice(-1)[0] : hjdNm;
    const { svgWidth, circleX, rectWidth, textX } = compactLayout(hjdLabel);

    return `<svg xmlns="http://www.w3.org/2000/svg" width="${svgWidth}px" height="150px">
        <defs><filter id="shadow"> <feDropShadow dx="3" dy="3"/></filter></defs>
        <g style="filter:url(#shadow);"><path style="fill:#002755" d="M74.5508 32.193c0 2.268-1.89 4.0446-4.032 4.0446h-4.032l.0882 20.1726c0 .3528-.0252.6804-.063 1.0206V59.472c0 2.7846-2.2554 5.04-5.04 5.04H59.456c-.1386 0-.2772-.1134-.4158-.0126-.1764-.1008-.3528.0126-.5292.0126H51.392c-2.7846 0-5.04-2.2554-5.04-5.04V48.384c0-2.2302-1.8018-4.032-4.032-4.032H34.256c-2.2302 0-4.032 1.8018-4.032 4.032v11.088c0 2.7846-2.2554 5.04-5.04 5.04H18.1406c-.189 0-.378-.0126-.567-.0252-.1512.0126-.3024.0252-.4536.0252H15.104c-2.7833 0-5.04-2.2554-5.04-5.04V45.36c0-.1134.0038-.2394.0113-.3528V36.2376H6.0383C3.7665 36.2376 2 34.461 2 32.193c0-1.134.3785-2.142 1.2613-3.024L35.5664 1.01c.882-.8838 1.89-1.01 2.772-1.01s1.89.2525 2.6586.8838L73.1648 29.169c1.008.882 1.5246 1.89 1.386 3.024z" /></g>
        <circle cx="13" cy="80" r="13.6" style="fill:#303030"/>
        <circle cx="${circleX}" cy="80" r="13.6" style="fill:#303030"/> 
        <rect x="11" y="66.5" width="${rectWidth}" height="27" style="fill:#303030"/> 
        <text x="11" y="78" transform="translate(40)" font-size="9" align="center" style="fill:rgb(255,255,255)"> 
        <tspan x="${textX}" text-anchor="middle">${hjdLabel}</tspan></text> 
        <text x="11" y="89" transform="translate(40)" font-size="9" align="center" style="fill:rgb(255,255,255)"> 
        <tspan x="${textX}" text-anchor="middle">${label}</tspan></text> </svg>`;
};

export const buildPopulationSymbol = (feature, type) => {
    let label = '';
    if (type?.includes('pop')) {
        label = `${formatNumber(feature.get('pop_cnt'))} 명`;
    } else if (type?.includes('share')) {
        label = `${feature.get('pop_share')} %`;
    } else if (type?.includes('in')) {
        label = `${formatNumber(feature.get('i_pop_cnt'))} 명`;
    } else if (type?.includes('out')) {
        label = `${formatNumber(feature.get('o_pop_cnt'))} 명`;
    } else {
        label = `${formatNumber(feature.get('pop_cnt'))} 명`;
    }

    const hjdNm = (feature.get('hjd_nm') || '').trim();
    const hjdLabel = hjdNm.split(' ').length > 1 ? hjdNm.split(' ').slice(-1)[0] : hjdNm;
    const { svgWidth, circleX, rectWidth, textX } = compactLayout(hjdLabel);

    return `<svg xmlns="http://www.w3.org/2000/svg" 
        width="${svgWidth}px" height="120px">
            <defs><filter id="shadow"> <feDropShadow dx="3" dy="3"/></filter></defs>
            <g style="filter:url(#shadow);"><path style="fill:#002755" d="M 40 36 C 46.8 36 52 30.8 52 24 C 52 17.2 46.8 12 40 12 C 33.2 12 28 17.2 28 24 C 28 30.8 33.2 36 40 36 Z M 64 62 C 64 49.2 53.2 40 40 40 C 26.8 40 16 49.2 16 62 L 16 68 C 16 69.2 16.4 70 17.2 70.8 C 18 71.6 18.8 72 20 72 H 60 C 61.2 72 62 71.6 62.8 70.8 C 63.6 70 64 69.2 64 68 V 62 Z" /></g>
            <circle cx="13" cy="67" r="11.6" style="fill:#303030"/>
            <circle cx="${circleX}" cy="67" r="11.6" style="fill:#303030"/> 
            <rect x="11" y="55.5" width="${rectWidth}" height="22" style="fill:#303030"/> 
            <text x="11" y="65" transform="translate(40)" font-size="8" align="center" style="fill:rgb(255,255,255)"> 
            <tspan x="${textX}" text-anchor="middle">${hjdLabel}</tspan></text> 
            <text x="11" y="75" transform="translate(40)" font-size="8" align="center" style="fill:rgb(255,255,255)"> 
            <tspan x="${textX}" text-anchor="middle">${label}</tspan></text> </svg>`;
};

const lifestyleIcons = {
    hos: {
        icon: `
            <g transform="translate(0, 0)">
                <rect x="22" y="22" width="36" height="40" rx="8" fill="#fff5f5" stroke="#e53935" stroke-width="2"/>
                <path d="M28 38h24" stroke="#e53935" stroke-width="3"/>
                <path d="M40 30v16" stroke="#e53935" stroke-width="3"/>
                <rect x="28" y="46" width="8" height="12" fill="#e53935" rx="2"/>
                <rect x="44" y="46" width="8" height="12" fill="#e53935" rx="2"/>
                <circle cx="40" cy="32" r="4" fill="#ffe0e0" stroke="#e53935" stroke-width="2"/>
                <path d="M32 58h16" stroke="#e53935" stroke-width="2" stroke-linecap="round"/>
            </g>
        `,
        label: '의료시설',
    },
    edu: {
        icon: `
            <g transform="translate(0, 0)">
                <polygon points="20,36 40,22 60,36" fill="#3949ab" stroke="#1a237e" stroke-width="2"/>
                <rect x="24" y="36" width="32" height="26" fill="#5c6bc0" rx="4"/>
                <rect x="32" y="44" width="6" height="10" fill="#fff"/>
                <rect x="42" y="44" width="6" height="10" fill="#fff"/>
                <path d="M40 18l0 8" stroke="#fdd835" stroke-width="3" stroke-linecap="round"/>
                <circle cx="40" cy="16" r="3" fill="#fdd835"/>
            </g>
        `,
        label: '교육시설',
    },
};

const getLifestyleIcon = (feature, fallbackType) => {
    const type = feature.get('type') || fallbackType;
    if (type === 'hos' || type === 'edu') {
        return { ...lifestyleIcons[type], type };
    }
    return null;
};

export const buildLifestyleSymbol = (feature, { layerName, type } = {}) => {
    const label = `${formatNumber(feature.get('t_cnt'))} 개소`;

    const hjdNm =
        layerName === 'point'
            ? `${(feature.get('props')?.[0]?.name || '').slice(0, 5)}...`
            : (feature.get('admin_nm') || '').trim();

    const hjdLabel =
        layerName === 'point'
            ? feature.get('count') > 1
                ? ` 외 ${feature.get('count')} 개소`
                : '1 개소 '
            : hjdNm.split(' ').length > 1
            ? hjdNm.split(' ').slice(-1)[0]
            : hjdNm;

    const { svgWidth, circleX, rectWidth, textX } = compactLayout(hjdLabel);
    const iconInfo = getLifestyleIcon(feature, type);
    const iconMarkup = iconInfo?.icon ?? '';
    const labelDescription = iconInfo?.label ?? '생활정보';

    return `<svg xmlns="http://www.w3.org/2000/svg" width="${svgWidth}" height="120">
        <defs><filter id="shadow"><feDropShadow dx="3" dy="3"/></filter></defs>
        <g style="filter:url(#shadow);">
            <rect x="24" y="20" width="32" height="32" rx="8" fill="#0d47a1"/>
            ${iconMarkup}
        </g>
        <circle cx="13" cy="93" r="13.6" style="fill:#303030" />
        <circle cx="${circleX}" cy="93" r="13.6" style="fill:#303030" />
        <rect x="11" y="79.5" width="${rectWidth}" height="27" style="fill:#303030" />
        <text x="11" y="91" transform="translate(40)" font-size="9" align="center" style="fill:#fff">
            <tspan x="${textX}" text-anchor="middle">${hjdLabel}</tspan>
        </text>
        <text x="11" y="103" transform="translate(40)" font-size="9" align="center" style="fill:#fff">
            <tspan x="${textX}" text-anchor="middle">${labelDescription} · ${label}</tspan>
        </text>
    </svg>`;
};
